import { render, staticRenderFns } from "./LocationForm.vue?vue&type=template&id=70768dfc&scoped=true"
import script from "./LocationForm.vue?vue&type=script&lang=js"
export * from "./LocationForm.vue?vue&type=script&lang=js"
import style0 from "./LocationForm.vue?vue&type=style&index=0&id=70768dfc&prod&lang=css"
import style1 from "./LocationForm.vue?vue&type=style&index=1&id=70768dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70768dfc",
  null
  
)

export default component.exports